module.exports = __webpack_public_path__ + "static/Hugo1-fe892372bfd91b95d2c6c56007449b7c.jpg";